import { RELEASES } from '../lib/changelog'
import { APP_VERSION, BUILD_COMMIT, IS_DEV_BUILD, formatBuildTime } from '../lib/version'
import './Changelog.css'

function releaseDate(iso: string): string {
  const d = new Date(`${iso}T00:00:00`)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' })
}

export function Changelog({ onBack }: { onBack: () => void }) {
  return (
    <>
      <header className="nav nav--plain">
        <button className="icon-btn" onClick={onBack} aria-label="Back">
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 5l-7 7 7 7" />
          </svg>
        </button>
        <h1>What&rsquo;s new</h1>
      </header>

      <div className="scroll">
        <div className="cl__build glass">
          <strong>Version {APP_VERSION}</strong>
          {IS_DEV_BUILD ? (
            <p>
              Dev server — no build stamp. Restart Vite to pick up a version bump.
            </p>
          ) : (
            <p>
              Built {formatBuildTime()}
              <br />
              <code>{BUILD_COMMIT}</code>
            </p>
          )}
        </div>

        {RELEASES.map((release) => (
          <section key={release.version} className="cl__release">
            <h2 className="cl__version">
              {release.version}
              {/* Suppressed on the dev server: APP_VERSION is read at config load
                  there, so it can point at the wrong release. */}
              {!IS_DEV_BUILD && release.version === APP_VERSION && (
                <span className="cl__now">This build</span>
              )}
              <time dateTime={release.date}>{releaseDate(release.date)}</time>
            </h2>
            <ul className="cl__changes">
              {release.changes.map((change) => (
                <li key={change}>{change}</li>
              ))}
            </ul>
          </section>
        ))}

        {/* The running build isn't in the list — someone shipped without writing
            notes. Say so rather than letting the top entry impersonate it. */}
        {!IS_DEV_BUILD && !RELEASES.some((r) => r.version === APP_VERSION) && (
          <p className="cl__orphan">
            No release notes were written for {APP_VERSION}.
          </p>
        )}
      </div>
    </>
  )
}
